module.exports = __webpack_public_path__ + "img/tutorial_war_05.ad287faa.gif";